import { render, staticRenderFns } from "./ycGame.vue?vue&type=template&id=ebcce198&scoped=true"
import script from "./ycGame.vue?vue&type=script&lang=js"
export * from "./ycGame.vue?vue&type=script&lang=js"
import style0 from "./ycGame.vue?vue&type=style&index=0&id=ebcce198&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcce198",
  null
  
)

export default component.exports